import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@fluentui/react-components';
import { withValidation, AdapterFactory } from '@bingads-webui-react/validation';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const CustomAdapter = AdapterFactory({
  defaultValue: false,
  valueToInject: 'checked',
  functionToInject: 'onChange',
  convertEventToValue: event => event.target.checked,
});

const SwitchInternal = ({
  checked,
  onChange,
}) => {
  const i18n = useContext(I18nContext);

  return (
    <Switch
      checked={checked}
      onChange={onChange}
      label={i18n.getString(_TL_('Use my campaign settings'))}
    />
  );
};

SwitchInternal.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const ValidatedLevelSwitch = withValidation(SwitchInternal, CustomAdapter);
